/**
 * @generated SignedSource<<0f6751e213881a5653f36a6977d92fde>>
 * @relayHash 73d57abd2d51e33f7083b4a9cbe85f93
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 73d57abd2d51e33f7083b4a9cbe85f93

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePatientFileLockTakenOrReleasedSubscription$variables = Record<PropertyKey, never>;
export type usePatientFileLockTakenOrReleasedSubscription$data = {
  readonly patientFileLockTakenOrReleased: {
    readonly appointments: ReadonlyArray<{
      readonly id: string;
      readonly patient: {
        readonly patientFileLock: {
          readonly lockedAt: string | null;
          readonly lockedBy: string | null;
        };
      };
      readonly " $fragmentSpreads": FragmentRefs<"appointmentStatusCell_appointment">;
    }>;
    readonly lock: {
      readonly id: string;
      readonly lockedAt: string | null;
      readonly lockedBy: string | null;
    };
  };
};
export type usePatientFileLockTakenOrReleasedSubscription = {
  response: usePatientFileLockTakenOrReleasedSubscription$data;
  variables: usePatientFileLockTakenOrReleasedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedBy",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientFileLock",
  "kind": "LinkedField",
  "name": "lock",
  "plural": false,
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    (v2/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePatientFileLockTakenOrReleasedSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PatientFileLockFinalChange",
        "kind": "LinkedField",
        "name": "patientFileLockTakenOrReleased",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointments",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "patient",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PatientFileLock",
                    "kind": "LinkedField",
                    "name": "patientFileLock",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v1/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "appointmentStatusCell_appointment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePatientFileLockTakenOrReleasedSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PatientFileLockFinalChange",
        "kind": "LinkedField",
        "name": "patientFileLockTakenOrReleased",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointments",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "patient",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PatientFileLock",
                    "kind": "LinkedField",
                    "name": "patientFileLock",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v1/*:: as any*/),
                      (v0/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "missedCallsCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastMissedCallAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCompleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "takenBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "73d57abd2d51e33f7083b4a9cbe85f93",
    "metadata": {},
    "name": "usePatientFileLockTakenOrReleasedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "3071f78f19d84fd2a08f5aa6e4221239";

export default node;
